const BankIcon = ({ fill = "#E0E7FF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.88269 4.66668H7.88869M2.55202 6.66668V12.3333M5.21869 6.66668V12.3333M10.552 6.66668V12.3333M13.2187 6.66668V12.3333M1.21869 5.71334C1.21869 4.91534 1.54002 4.42668 2.20536 4.05601L4.94536 2.53134C6.38069 1.73334 7.09869 1.33334 7.88536 1.33334C8.67202 1.33334 9.39002 1.73334 10.8254 2.53134L13.5654 4.05601C14.23 4.42668 14.552 4.91534 14.552 5.71334C14.552 5.92934 14.552 6.03801 14.5287 6.12668C14.4047 6.59334 13.9814 6.66734 13.5727 6.66734H2.19802C1.78936 6.66734 1.36669 6.59401 1.24202 6.12668C1.21869 6.03734 1.21869 5.92934 1.21869 5.71334ZM12.552 12.3333H3.21869C2.68826 12.3333 2.17955 12.5441 1.80448 12.9191C1.4294 13.2942 1.21869 13.8029 1.21869 14.3333C1.21869 14.4217 1.25381 14.5065 1.31632 14.569C1.37883 14.6316 1.46362 14.6667 1.55202 14.6667H14.2187C14.3071 14.6667 14.3919 14.6316 14.4544 14.569C14.5169 14.5065 14.552 14.4217 14.552 14.3333C14.552 13.8029 14.3413 13.2942 13.9662 12.9191C13.5912 12.5441 13.0825 12.3333 12.552 12.3333Z"
        stroke="#6366F1"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default BankIcon;
